import { useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'

export function useAccountLayout() {
  const { isAuthenticated } = useAuth()
  const { pathname } = useLocation()

  return {
    isAuthenticated,
    loginFrom: pathname,
  }
}
